import { computed } from 'vue'
import { usePresentStore } from '@/stores/presentStore'
import { useWeatherWaringStore } from '@/stores/weatherWarningStore'

export const useAlert = () => {
  const weatherWarning = useWeatherWaringStore()
  const presentStore = usePresentStore()

  const maxThresholdLevel = computed(() => {
    return presentStore.maxAlertLevel || 0
  })

  const maxWeatherLevel = computed(() => {
    return weatherWarning.maxAlertLevel || 0
  })

  return {
    maxThresholdLevel,
    maxWeatherLevel,
  }
}
